/* global Vue, AZURE_URI, LOCALE */

import ListProperties from './ListProperties'

export default {
  name: 'PropertySelector',
  components: { ListProperties },
  template: `
  <div class="property-selector">
    <div class="property-selector__destination" ref="destinationsRef">
      <ul class="no-bullets">
        <li v-for="destination in destinations" :key="destination">
          <button @click="changeDestination(destination)" :class="{ active: selectedDestination === destination }">
            <span>{{ destination }}</span>
            <i :class="'icon-caret-' + (selectedDestination === destination ? 'up' : 'down')"></i>
          </button>
          <div v-if="selectedDestination === destination" class="properties" ref="destinationPropertiesRef">
            <ListProperties
              :loadingSkeleton="loadingSkeleton"
              :hotelsAndResorts="hotelsAndResorts"
              :campsites="campsites"
              @focusImage="focusImage = $event"
              @updateProperty="$emit('updateProperty', $event)" />
          </div>
        </li>
      </ul>
    </div>
    <div class="property-selector__property properties">
      <ListProperties
        :loadingSkeleton="loadingSkeleton"
        :hotelsAndResorts="hotelsAndResorts"
        :campsites="campsites"
        @focusImage="focusImage = $event"
        @updateProperty="$emit('updateProperty', $event)" />
    </div>
    <div class="property-selector__image" v-if="focusImage">
      <img :src="focusImage" />
    </div>
  </div>
  `,
  props: {
    property: Object,
  },
  emits: ['updateProperty'],
  setup (props, { emit }) {
    const destinationsRef = Vue.ref(null)
    const selectedDestination = Vue.ref(props.property?.destination)
    const destinations = ['rovinj', 'vrsar', 'split', 'zagreb', 'dubrovnik']
    const allProperties = Vue.ref([])
    const propertiesLoading = Vue.ref(true)
    const destinationProperties = Vue.computed(() => allProperties.value
      .filter(p => p.destination === selectedDestination.value)
      .sort((a, b) => (a.propertyListingWeight ?? Number.MAX_VALUE) - (b.propertyListingWeight ?? Number.MAX_VALUE)))

    const hotelsAndResorts = Vue.computed(() => destinationProperties.value.filter(p => p.menuGroup !== 'camping'))
    const campsites = Vue.computed(() => destinationProperties.value.filter(p => p.menuGroup === 'camping'))
    const loadingSkeleton = Vue.computed(() => propertiesLoading.value
      ? {
          hotelsAndResorts: Array.from({ length: 7 }),
          campsites: ['split', 'zagreb', 'dubrovnik'].includes(selectedDestination.value) ? null : Array.from({ length: 7 }),
        }
      : {})

    const focusImage = Vue.ref(props.property?.image)

    async function getProperties () {
      const response = await fetch(`${AZURE_URI}GetProperties?locale=${LOCALE}`, { priority: 'high' })
      propertiesLoading.value = false
      allProperties.value = (await response.json()).filter(p => p.phobsId)
    }

    function changeDestination (destination) {
      if (!window.matchMedia('(min-width: 768px)').matches && selectedDestination.value === destination) {
        selectedDestination.value = null
        focusImage.value = null

        destinationsRef.value.scrollIntoView()
        return
      }

      selectedDestination.value = destination
      if (!window.matchMedia('(min-width: 768px)').matches) destinationsRef.value.scrollIntoView()

      if (destinationProperties.value[0]) {
        focusImage.value = destinationProperties.value[0].image
      }
    }

    getProperties()

    return {
      destinationsRef,
      destinations,
      selectedDestination,
      loadingSkeleton,
      hotelsAndResorts,
      campsites,
      focusImage,
      changeDestination,
    }
  },
}
